import { render } from "./ApproveTopup.vue?vue&type=template&id=3cf43c1b"
import script from "./ApproveTopup.vue?vue&type=script&lang=js"
export * from "./ApproveTopup.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2796879663/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__